import { useEffect, useRef } from "react";

/** Returns a ref that is false once the component has unmounted (e.g. after navigating away mid-request). */
export function useIsMounted() {
    const mounted = useRef(true);
    useEffect(() => {
        mounted.current = true;
        return () => { mounted.current = false; };
    }, []);
    return mounted;
}
